<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import CrmLayout from './layouts/CrmLayout'
import EmptyLayout from './layouts/EmptyLayout'
import LoginLayout from './layouts/LoginLayout'
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
  },
  components: {
    CrmLayout,
    LoginLayout,
    EmptyLayout,
  },
}
</script>

<style lang="scss">
body {
  background: #fff;
  position: relative;
}
#app {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /*@media screen and (max-width: 768px) {*/
  /*    position: static;*/
  /*}*/
}
.chart-wrapp #doughnut-chart {
  @media screen and (max-height: 710px) {
    height: 230px !important;
    width: 230px !important;
    margin: 0 auto;
  }
}
.empty-layout {
  background-color: #eee;
}
.md-steppers-navigation {
  display: none;
}
.md-steppers-wrapper {
  background-color: #eee;
}
.md-menu-content.md-select-menu,
.md-tooltip {
  z-index: 10000;
}
.md-tooltip {
  max-width: 800px;
}
</style>
